if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        if (!button) return;

        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
        });
      }

expandShowMore(event) {
        const parentDisplay = this.closest('.parent-display');
        if (!parentDisplay) return;

        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => {
          item.classList.toggle('hidden');
        });

        this.querySelectorAll('.label-show-more, .label-show-less').forEach((label) => {
          label.classList.toggle('hidden');
        });
        
        const isOpening = !this.querySelector('.label-show-more').classList.contains('hidden');
        if (isOpening) {
           const firstInput = parentDisplay.querySelector('input');
           if (firstInput) firstInput.focus();
        }
      }
    }
  );
}